<template>
	<div class="cms-html-block">
		<div v-if="hasErrors" class="cms-html-block__error-bar">
			<i class="fa fa-exclamation-triangle"></i>
			Broken HTML — {{ errorCount }} {{ errorCount === 1 ? 'issue' : 'issues' }} found
		</div>
		<div v-html="sanitizedContent"></div>
	</div>
</template>

<script>
/**
 * HtmlBlock.vue
 * ─────────────
 * Renders raw HTML content. Intended for embedding custom widgets,
 * forms, or third-party snippets that the RichText block can't handle.
 *
 * SECURITY: Strips <script> tags and inline event handlers as a
 * defence-in-depth measure via the shared sanitizeHtml utility.
 *
 * VALIDATION: Shows a warning bar in the editor when the HTML has
 * structural issues (unclosed/mismatched tags). The content still
 * renders (browsers auto-correct), but the warning alerts the user.
 */
import { sanitizeHtml, validateHtml } from '@/websites/cms/blocks/shared/blockUtils.js';

export default {
	name: 'HtmlBlock',

	props: {
		htmlContent: {
			type: String,
			default: ''
		}
	},

	computed: {
		sanitizedContent: function () {
			return sanitizeHtml(this.htmlContent);
		},

		validation: function () {
			return validateHtml(this.htmlContent);
		},

		hasErrors: function () {
			return !this.validation.valid;
		},

		errorCount: function () {
			return this.validation.errors.length;
		}
	}
};
</script>

<style scoped>
.cms-html-block {
	padding: 0;
	line-height: 1.6;
	word-wrap: break-word;
}

.cms-html-block__error-bar {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 6px 10px;
	margin-bottom: 6px;
	background: rgba(227, 21, 21, 0.08);
	border: 1px solid rgba(227, 21, 21, 0.25);
	border-radius: 4px;
	color: #E31515;
	font-size: 1em;
	font-weight: 600;
}
</style>
